export const updateProducerIsLoadingSelector = state => state.producers.updateProducer.isLoading